/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PriceListNoteApiDto {
  code?: string;
  subject?: PriceListNoteApiDto.SubjectEnum;
  title?: string;
  text?: string;
}
export namespace PriceListNoteApiDto {
  export const SubjectEnum = {
    COURSES: 'COURSES',
    ACCOMMODATION: 'ACCOMMODATION',
    TRANSFER_SERVICE_FEES: 'TRANSFER_SERVICE_FEES',
    GENERAL_FEES: 'GENERAL_FEES',
    TUITION_UPGRADES_ADD_ONS: 'TUITION_UPGRADES_ADD_ONS',
    PRIVATE_LESSONS: 'PRIVATE_LESSONS',
    ACCOMMODATION_SUPPLEMENT: 'ACCOMMODATION_SUPPLEMENT',
    PEAK_SEASON_SUPPLEMENT: 'PEAK_SEASON_SUPPLEMENT',
    PATHWAY_PROGRAM: 'PATHWAY_PROGRAM',
    PATHWAY_PROGRAM_FEES: 'PATHWAY_PROGRAM_FEES',
    ADDITIONAL_INFORMATION: 'ADDITIONAL_INFORMATION',
    EXAM_PREP_COURSES: 'EXAM_PREP_COURSES',
    PRIVATE_COURSES_ONLINE_LESSONS: 'PRIVATE_COURSES_ONLINE_LESSONS',
    STUDY_LANGUAGE_WORK_EXPERIENCE_INTERNSHIP: 'STUDY_LANGUAGE_WORK_EXPERIENCE_INTERNSHIP',
    STUDY_LANGUAGE_VOLUNTEERING: 'STUDY_LANGUAGE_VOLUNTEERING',
    STUDENT_PREPARATION: 'STUDENT_PREPARATION',
    ONLINE_COURSES: 'ONLINE_COURSES',
    ONLINE_LIVE_PRACTICE: 'ONLINE_LIVE_PRACTICE',
    ONLINE_LIVE_PRACTICE_GROUPS: 'ONLINE_LIVE_PRACTICE_GROUPS',
    ONLINE_YOUNG_LEARNERS: 'ONLINE_YOUNG_LEARNERS',
    ONLINE_SUPPLEMENTARY_FEES: 'ONLINE_SUPPLEMENTARY_FEES',
    CAMP_INCLUDED_IN_PACKAGE: 'CAMP_INCLUDED_IN_PACKAGE',
    CAMP_START_END_DATES: 'CAMP_START_END_DATES',
    YOUNG_ADULTS_INCLUDED_IN_PACKAGE: 'YOUNG_ADULTS_INCLUDED_IN_PACKAGE',
    YOUNG_ADULTS_COURSES: 'YOUNG_ADULTS_COURSES',
    YOUNG_ADULTS_START_END_DATES: 'YOUNG_ADULTS_START_END_DATES',
    YOUNG_ADULTS_TRANSFERS: 'YOUNG_ADULTS_TRANSFERS',
    PREMIUM_ACTIVITIES: 'PREMIUM_ACTIVITIES',
  } as const;
  export type SubjectEnum = (typeof SubjectEnum)[keyof typeof SubjectEnum];
}
